module.exports = __webpack_public_path__ + "img/business8.89399c8d.png";